export const TOGGLE_ADD_INVOICE_MODAL = "TOGGLE_ADD_INVOICE_MODAL";
export const TOGGLE_ADD_CUSTOMER_MODAL = "TOGGLE_ADD_CUSTOMER_MODAL";
export const TOGGLE_TAKE_PAYMENT_MODAL = "TOGGLE_TAKE_PAYMENT_MODAL";
export const SET_INVOICE_CUSTOMER = "SET_INVOICE_CUSTOMER";

export const toggleAddInvoice = bool => ({ type: TOGGLE_ADD_INVOICE_MODAL, payload: bool});
export const toggleAddCustomer = bool => ({ type: TOGGLE_ADD_CUSTOMER_MODAL, payload: bool});
export const toggleTakePayment = bool => ({ type: TOGGLE_TAKE_PAYMENT_MODAL, payload: bool});
export const setInvoiceCustomer = customer => ({type: SET_INVOICE_CUSTOMER, payload: customer});